<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.063.062h19.875v19.876H.063V.062z" />
    <path
      d="M18.281 1.113L2.998 19.938l-1.28-1.051L4.9 14.969H3.387V6.688h4.129v5.044l1.667-2.04V6.688l4.443-2.47L17.002.064l1.28 1.05zm-9.098 13.19v.666l7.442 4.14V5.136l-7.442 9.166z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
